import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { useOutsideClick } from '../utils/useOutsideClick';

import giraffeImgUrl from '../images/Zyrafa_v2.png';
import closeImgUrl from '../icons/close.svg';

const Popup = ({ children, onClose }) => {
  const popupContainer = useRef();

  useOutsideClick(popupContainer, onClose);

  return (
    <div className="popup">
      <div className="popup__container" ref={popupContainer}>
        <div className="popup__image">
          <img src={giraffeImgUrl} alt="Żyrafka" />
        </div>
        {!!onClose && (
          <button className="popup__close" onClick={onClose}>
            <img src={closeImgUrl} alt="Close Button" />
          </button>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

Popup.propTypes = {
  children: PropTypes.any.isRequired,
  close: PropTypes.func,
};

export default Popup;
